import { dataTestIds } from '@velasca/constants'
import {
  Container,
  SizeGuideLink,
  StyledSizesGroup,
  Title,
} from './QuickAddToCartDesktop.styles'
import type { QuickAddToCartDesktopProps } from './QuickAddToCartDesktop.types'

export const QuickAddToCartDesktop = ({
  title,
  sizeGuideUrl,
  sizeGuideText,
  sizes,
  onSizeSelect,
  isOpen,
  status,
  selectedSize,
  isGiftCard = false,
}: QuickAddToCartDesktopProps): JSX.Element | null => {
  return isOpen || status !== 'idle' ? (
    <Container>
      {Boolean(title) && (
        <Title data-testid={dataTestIds.ADD_TO_CART_TEXT}>{title}</Title>
      )}
      <StyledSizesGroup
        isRequired
        status={status}
        sizes={sizes}
        isGiftCard={isGiftCard}
        selectedSize={selectedSize}
        onSizeChange={onSizeSelect}
      />
      {sizeGuideUrl ? (
        <SizeGuideLink
          color="primary"
          as="a"
          fontStyle="italic"
          href={sizeGuideUrl}
        >
          {sizeGuideText}
        </SizeGuideLink>
      ) : null}
    </Container>
  ) : null
}
